module.exports = __webpack_public_path__ + "img/qavatar.eec915f3.png";